export default function User({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 12C21 15.1311 19.4011 17.8887 16.9752 19.501C16.9916 19.3362 17 19.1691 17 19C17 16.8948 15.699 15.0935 13.8571 14.3562C14.5532 13.8069 15 12.9556 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 12.9556 9.4468 13.8069 10.1429 14.3562C8.30103 15.0935 7 16.8948 7 19C7 19.1691 7.00839 19.3362 7.02479 19.501C4.59891 17.8887 3 15.1311 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        fill="currentColor"
      />
    </svg>
  )
}
